export default __webpack_public_path__ + "static/1222-2b3dd2959e08b7fe0c4b83ac993940e6.gif";